"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailTemplateTypes = void 0;
var EmailTemplateTypes;
(function (EmailTemplateTypes) {
    EmailTemplateTypes[EmailTemplateTypes["CompanySignUp"] = 0] = "CompanySignUp";
    EmailTemplateTypes[EmailTemplateTypes["CompanyApproved"] = 1] = "CompanyApproved";
    EmailTemplateTypes[EmailTemplateTypes["OrderReceipt"] = 2] = "OrderReceipt";
    EmailTemplateTypes[EmailTemplateTypes["OrderReceiptCopy"] = 3] = "OrderReceiptCopy";
    EmailTemplateTypes[EmailTemplateTypes["PaymentFailed"] = 4] = "PaymentFailed";
    EmailTemplateTypes[EmailTemplateTypes["RefundSuccess"] = 5] = "RefundSuccess";
    EmailTemplateTypes[EmailTemplateTypes["InvoiceIntegrationFailed"] = 6] = "InvoiceIntegrationFailed";
    EmailTemplateTypes[EmailTemplateTypes["InvoiceIntegrationFailedSupport"] = 7] = "InvoiceIntegrationFailedSupport";
    EmailTemplateTypes[EmailTemplateTypes["AnalyticsRevenueSummary"] = 8] = "AnalyticsRevenueSummary";
    EmailTemplateTypes[EmailTemplateTypes["GiftCardSharing"] = 9] = "GiftCardSharing";
    EmailTemplateTypes[EmailTemplateTypes["ZReport"] = 10] = "ZReport";
    EmailTemplateTypes[EmailTemplateTypes["CompanyMemberInvitation"] = 11] = "CompanyMemberInvitation";
    EmailTemplateTypes[EmailTemplateTypes["PreOrderLink"] = 12] = "PreOrderLink";
    EmailTemplateTypes[EmailTemplateTypes["GroupPreOrderApproved"] = 13] = "GroupPreOrderApproved";
    EmailTemplateTypes[EmailTemplateTypes["GroupPreOrderRejected"] = 14] = "GroupPreOrderRejected";
    EmailTemplateTypes[EmailTemplateTypes["IdentityEmailVerification"] = 15] = "IdentityEmailVerification";
    EmailTemplateTypes[EmailTemplateTypes["LargeDeliveryOrderReminder"] = 16] = "LargeDeliveryOrderReminder";
})(EmailTemplateTypes = exports.EmailTemplateTypes || (exports.EmailTemplateTypes = {}));
